import { Button, ButtonProps, useDisclosure } from "@chakra-ui/react";
import { lazy, Suspense, useState } from "react";
import { useNavigate } from "react-router-dom";
import useCustomToast from "../../lib/useCustomToast";
import { getAxiosInstance } from "../../utils/helperFunction";
import { SpinnerLoading } from "../spinner/SpinnerLoading";

const ConfirmationModal = lazy(() => import("../modal/ConfirmationModal"));

interface Props extends ButtonProps {
  title?: string;
  endpoint: string;
  pageType?: number; // 1 = buyer, 2 = reseller, 3 = supplier
}

export const DeleteProductButton = ({
  title = "Hapus Produk",
  endpoint,
  pageType = 3,
  ...rest
}: Props) => {
  const [loading, setLoading] = useState<boolean>(false);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useCustomToast();
  const navigate = useNavigate();

  const deleteProduct = () => {
    setLoading(true);

    const axiosInstance = getAxiosInstance(pageType);

    axiosInstance
      .delete(endpoint)
      .then((res) => {
        toast({
          title: res.data.message,
          status: "success",
        });
        onClose();
        navigate(-1);
      })
      .catch((err) => {
        toast({
          description: err?.response?.data?.message || "",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Button
        w={"fit-content"}
        size={["xs", null, "sm"]}
        variant={"ghost"}
        onClick={onOpen}
        {...rest}
      >
        {title}
      </Button>

      <Suspense fallback={<SpinnerLoading />}>
        <ConfirmationModal
          isOpen={isOpen}
          onOpen={onOpen}
          onClose={onClose}
          title="Hapus Produk"
          subtitle="Apakah anda yakin ingin menghapus produk ini?"
          btnText="Hapus"
          onClickSubmit={() => {
            deleteProduct();
          }}
          loading={loading}
          children={undefined}
        />
      </Suspense>
    </>
  );
};
